import { combineReducers } from 'redux';
import { listCandidatesReducer } from './list-candidates';
// import { deleteDepartmentReducer } from './delete-department';

export default combineReducers({
  list: listCandidatesReducer,
  // delete: deleteDepartmentReducer,
});
